var uiAssetClassBadge = {
	bond: "Obbligazione",
	commodity: "Materie Prime",
	currency: "Valuta",
	debt: "Debito",
	etf: "ETF",
	fund: "Fondo",
	generic: "Generico",
	index: "Indice",
	stock: "Azione",
	interestRate: "Tasso di Interesse",
	structuredProduct: "Prodotto Strutturato",
	investmentProduct: "Prodotto di Investimento",
	leveragedProduct: "Prodotto a Leva",
	future: "Future",
	option: "Opzione"
};
var it = {
	uiAssetClassBadge: uiAssetClassBadge
};

export { it as default, uiAssetClassBadge };
